<template>
  <div>
    <h1 class="text-5xl font-medium leading-none text-zinc-800">{{ __('Create new job requisition') }}</h1>
  </div>
  <div class="mt-8 md:grid md:grid-cols-2">
    <SectionHeader icon="contract_edit" :title="__('Details')" />
  </div>
  <div>
    <form @submit.prevent="handleSubmit">
      <requisition-form
          v-model="requisition"
          :errors="errors"
          :isLoading="isLoading"
          :action="action"
          @cancel="redirectToListing"
      />
    </form>
  </div>
</template>

<script setup>
import {reactive, ref} from 'vue';
import axios from 'axios';
import { useToast } from 'vue-toastification';
import { RequisitionForm } from "./partials";
import {__} from "../../../helpers";
import { SectionHeader } from "../../../components/global";

const props = defineProps({
  requisition: {
    type: Object,
    required: true,
  }
})


const toast = useToast();
const isLoading = ref(false);
const requisition = ref(props.requisition);
const errors = reactive({})
const action = ref('create')

const handleSubmit = async () => {
  isLoading.value = true

  try {
    const response = await axios.post(
        route('redesign.company.requisitions.store'),
        requisition.value
    )
    Object.keys(errors).forEach(key => delete errors[key])
    toast.success(response.data.message)

    setTimeout(function(){
      window.location.href = route('redesign.company.requisitions.index')
    }, 1200)

  } catch (err) {
    if (err.response?.data?.errors) {
      Object.assign(errors, err.response.data.errors)
    } else {
      toast.error(err.response?.data?.message || __('An unexpected error occurred'))
    }
  } finally {
    isLoading.value = false
  }
}

const redirectToListing = () => {
  window.location.href = route('redesign.company.requisitions.index')
}

</script>
